/**
 * src/shell/save/keys.ts — 外壳存档键命名空间（设计稿 §5.1.1 / 引擎 §8.2 分治）。
 *
 * 分治纪律：外壳拥有 thirdplay:v2:*（含 apikey 键），引擎拥有 tp3:*。
 * 铁律：apikey 键永不入 bundle、永不入导出、任何对外 dump 排除。
 */

import type { SaveBundle } from '../../gm'

export type BundleKey = keyof SaveBundle // save | projects | decisions | reviews | employees | market

export const NS = 'thirdplay:v2'

export const BUNDLE_KEYS: BundleKey[] = [
  'save',
  'projects',
  'decisions',
  'reviews',
  'employees',
  'market',
]

export const bundleKey = (f: BundleKey): string => `${NS}:${f}`

/** 初始化标记（值 = 首次初始化时间 ISO） */
export const INIT_KEY = `${NS}:initialized`

/** 人才市场候选（外壳自有键——引擎 SaveBundle 无此键，以 web/src/gm 代码为准） */
export const CANDIDATES_KEY = `${NS}:candidates`

/** BYOK Key（独立键。铁律：永不进代码仓库、永不入导出、任何 dump 排除） */
export const APIKEY_KEY = `${NS}:apikey`
export const APIKEY_MODE_KEY = `${NS}:apikey-mode` // 'local' | 'session'

/** 外壳本地 UI 状态：事件未读（last-read seq，评审对齐项 3——不落引擎事件流） */
export const LASTREAD_KEY = `${NS}:ui:lastread`

/** 滚动备份环（最近 3 份写前快照；存档损坏一键回滚用） */
export const BACKUP_RING = 3
export const backupKey = (n: number): string => `${NS}:backup:${n}`
